module.exports = __webpack_public_path__ + "img/11_2023_07_19.bb161cb2.png";